import { render, staticRenderFns } from "./UserReferralReferralsFilters.vue?vue&type=template&id=aa8a07ce&"
import script from "./UserReferralReferralsFilters.vue?vue&type=script&lang=js&"
export * from "./UserReferralReferralsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports